import { Key } from '@briebug/ngrx-auto-entity';

export class JobPlanManaged {
  @Key id: string;
  manager: string;
  jobPlan: string;
  delta: number;
}
